export const styles = {
  detailsContainer: {
    textAlign: "center",
    boxShadow: "0px 0px 40px rgba(0, 0, 0, 1)",
    width: "80%",
    padding: "25px",
    margin: "20px",
  } as const,
  button: {
    margin: "10px",
    "&:hover": {
      backgroundColor: "#1A8899",
    },
    width: "120px",
    color: "black",
    backgroundColor: "#27B6CB",
  } as const,
};
